import { render, staticRenderFns } from "./AddSaleReturn.vue?vue&type=template&id=672800ae&scoped=true&"
import script from "./AddSaleReturn.vue?vue&type=script&lang=js&"
export * from "./AddSaleReturn.vue?vue&type=script&lang=js&"
import style0 from "./AddSaleReturn.vue?vue&type=style&index=0&id=672800ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672800ae",
  null
  
)

export default component.exports